/**
 * Aimepic Company Landing Page Content
 * 
 * Static content for the company landing page at root "/"
 * Presents Aimepic as a software company with portfolio featuring OneCare
 */

import { COMPANY_BRANDING } from './companyBranding';

export const COMPANY_LANDING_CONTENT = {
  // Hero Section
  hero: {
    title: COMPANY_BRANDING.company.name,
    tagline: COMPANY_BRANDING.company.tagline,
    description: COMPANY_BRANDING.company.description,
    ctaButtons: [
      { 
        text: 'Explore OneCare Platform', 
        link: '/onecare/', 
        primary: true,
        description: 'View our flagship healthcare operations platform',
      },
      { 
        text: 'Contact Us',
        link: '/contact',
        primary: false,
        description: 'Get in touch with our team',
      },
    ],
    stats: [
      { value: 'Work & Life', label: 'One Software Suite' },
      { value: 'Privacy', label: 'First Design' },
      { value: '24/7', label: 'Support' },
      { value: 'Enterprise', label: 'Grade Security' },
    ],
  },

  // About Aimepic Section
  about: {
    title: 'About Aimepic',
    subtitle: 'Technology That Turns Complexity Into Clarity',
    mission: COMPANY_BRANDING.mission,
    vision: COMPANY_BRANDING.vision,
    expertise: COMPANY_BRANDING.expertise,
    valueProps: COMPANY_BRANDING.valueProps,
  },

  // Portfolio Section
  portfolio: {
    title: 'Our Solutions',
    subtitle: 'A growing suite of secure, intelligent software products',
    featured: COMPANY_BRANDING.portfolio.products[0], // OneCare
  },

  // Call to Action Section
  cta: {
    title: 'Ready to Bring Clarity to Your Operations?',
    subtitle: 'Discover how Aimepic\'s solutions can help your organization work smarter and safer',
    buttons: [
      { 
        text: 'Explore OneCare Platform', 
        link: '/onecare/', 
        primary: true,
      },
      { 
        text: 'Login to OneCare', 
        link: '/onecare/login', 
        primary: false,
      },
      { 
        text: 'Contact Sales',
        link: '/contact',
        primary: false,
      },
    ],
  },

  // Contact Section
  contact: {
    title: 'Get in Touch',
    subtitle: 'Let\'s discuss how we can help your organization',
    email: COMPANY_BRANDING.contact.email,
    salesEmail: COMPANY_BRANDING.contact.salesEmail,
    supportEmail: COMPANY_BRANDING.contact.supportEmail,
  },

  // SEO Metadata
  seo: {
    title: COMPANY_BRANDING.meta.defaultTitle,
    description: COMPANY_BRANDING.meta.defaultDescription,
    keywords: COMPANY_BRANDING.meta.keywords,
    ogImage: '/images/aimepic-og-image.png',
    twitterCard: 'summary_large_image',
  },
} as const;

// Export individual sections for convenience
export const { hero, about, portfolio, cta, contact, seo } = COMPANY_LANDING_CONTENT;

// Default export
export default COMPANY_LANDING_CONTENT;
